import { takeEvery, fork, put, all, call } from "redux-saga/effects"
import { delay } from "redux-saga/effects";

//Account Redux states
import { REGISTER_USER } from "./actionTypes"
import { registerUserSuccessful, registerUserFailed } from "./actions"

//Include Both Helper File with needed methods
import { getFirebaseBackend } from "../../../helpers/firebase_helper"
import { postJwtRegister } from "../../../helpers/blopsleads_helper"
import { POST_JWT_REGISTER } from "helpers/url_helper"

// initialize relavant method of both Auth
const fireBaseBackend = getFirebaseBackend()

// Is user register successfull then direct plot user in redux.
function* registerUser({ payload: { user, history } }) {
  try {

     if (process.env.REACT_APP_DEFAULTAUTH === "jwt") {
      console.log("User_Register:", user);
      const response = yield call(postJwtRegister, user)
      yield put(registerUserSuccessful(response))
      yield delay(2500);
      history.push("/login");
      yield put(registerUserFailed(null))
      
  }} catch (error) {
    console.log("There was an error registering:", error)
    yield put(registerUserFailed(error.response.data.message))
  }
}

export function* watchUserRegister() {
  yield takeEvery(REGISTER_USER, registerUser)
}

function* accountSaga() {
  yield all([fork(watchUserRegister)])
}

export default accountSaga
